import script from "./PoliciesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoliciesView.vue?vue&type=script&setup=true&lang=ts"

import "./PoliciesView.vue?vue&type=style&index=0&id=5d45f81c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d45f81c"]])

export default __exports__